import * as v from 'valibot';

const ChoiceSchema = v.object({
    name: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Le libellé est requis.')
    ),
    isNone: v.boolean(),
});

export type ChoicePayload = v.InferOutput<typeof ChoiceSchema>;

export type Choice = ChoicePayload & {
    id: number;
}

export const QuestionCoreSchema = v.object({
    ordinal: v.number(),
    title: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Le titre est requis.')
    ),
    isSingleAnswer: v.boolean(),
    isShuffledAnswers: v.boolean(),
});

export type QuestionCore = v.InferOutput<typeof QuestionCoreSchema>;

export const QuestionSchema = v.object({
    ...QuestionCoreSchema.entries,
    choices: v.pipe(
        v.array(ChoiceSchema),
        v.minLength(2)
    ),
});

export type QuestionPayload = v.InferOutput<typeof QuestionSchema>;

export type Question = {
    id: number;
    uuid: string;
    ordinal: number;
    createdAt: string;
    title: string;
    isSingleAnswer: boolean;
    isShuffledAnswers: boolean;
    choices: Array<Choice>
};

const BroadcastGroupSchema = v.object({
    name: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Le titre est requis.')
    ),
});

export type BroadcastGroupPayload = v.InferOutput<typeof BroadcastGroupSchema>;

export type BroadcastGroup = BroadcastGroupPayload & {
    id: number;
    uuid: string;
}
